import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import svgIcons from "../../assets/svg/svgIcons";
import ScreenMapAsset from "../map-asset/map-asset";
import { crashtrack_tab_slugs } from "./crash-track-admin-details";
import { CrashTrackTabParams } from "./type";
import { APP_CONFIG } from "../../constants/constants";

const ScreenCrashTrackTabIncidentMap = ({
  assetCrashIdAsset,
  assetCrashIdTimestamp,
  onLoadComplete,
  printMode = false,
}: CrashTrackTabParams) => {
  const tab_slug = crashtrack_tab_slugs[4]; // "incident_map";
  const { t: tCrashTrackDetails } = useTranslation("translation", {
    keyPrefix: `admins.crashtrack.detailsPage`,
  });
  const { t } = useTranslation("translation", {
    keyPrefix: `admins.crashtrack.detailsPage.tab_${tab_slug}`,
  });
  const hasCalledLoadComplete = useRef(false);

  // trigger onLoadComplete 10 seconds after component is mounted to ensure map is loaded
  // instead of using this 10 seconds mechanism, `onLoadComplete` is passed and called in
  // the ScreenMapAsset component
  // ------------------------------------------------------------------------------------
  // let timer: any;
  // useEffect(() => {
  //   timer = setTimeout(() => {
  //     if (printMode && !hasCalledLoadComplete.current) {
  //       onLoadComplete?.();
  //       if (APP_CONFIG.DEBUG.ALL)
  //         console.log(
  //           "===== CRASH TRACK TAB LOADED",
  //           tab_slug,
  //           new Date().getTime()
  //         );
  //       hasCalledLoadComplete.current = true;
  //     }
  //   }, 10 * 1000);
  // }, [printMode, onLoadComplete]);
  // useEffect(() => {
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    if (APP_CONFIG.DEBUG.ALL)
      console.log("===== INCIDENT MAP PROP CHANGE", {
        assetCrashIdAsset,
        assetCrashIdTimestamp,
      });
  }, [assetCrashIdAsset, assetCrashIdTimestamp]);

  // not usable as map component needs to laod below
  if (false)
    return (
      <div className="flex-grow flex items-center justify-center min-h-64">
        <img src={svgIcons.LoadingAnimation} alt="" className="size-12" />
      </div>
    );

  // not usable as map component needs to laod below
  if (false) {
    return (
      <div className="flex flex-col items-center justify-center min-h-64 text-center">
        <p className="font-bold text-xl text-gray-400 px-8">
          {tCrashTrackDetails("tab_data_fetch_error")}
        </p>
      </div>
    );
  }

  return (
    <div className="printable-landscape-page flex flex-col gap-4 p-4">
      <h2 className="font-semibold text-lg">{t("heading")}</h2>
      <div className="flex flex-col bg-white rounded-lg">
        <ScreenMapAsset
          key={`map-asset-crashtrack-${assetCrashIdTimestamp}`} // ensures that map refreshes when changing timestamp dropdown
          crashTrackEventData={{
            assetCrashIdAsset,
            assetCrashIdTimestamp,
            onLoadComplete: () => {
              setTimeout(() => {
                if (!hasCalledLoadComplete.current) {
                  onLoadComplete?.();
                  if (APP_CONFIG.DEBUG.ALL)
                    console.log(
                      "===== CRASH TRACK TAB LOADED",
                      tab_slug,
                      new Date().getTime()
                    );
                  hasCalledLoadComplete.current = true;
                }
              }, 2000);
            },
          }}
        />
      </div>
    </div>
  );
};
export default ScreenCrashTrackTabIncidentMap;
